import {
  FormControl,
  FormHelperText,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
  Typography
} from '@mui/material';
import React from 'react';


export type StyledDropDownProps = {
  validationErrorMessage?: string;
  isValid?: boolean;
  label?: string;
  multiple?: boolean;
  onChange: (e: SelectChangeEvent<unknown>) => void;
  options: {
    id: string;
    name: string;
    displayName: string;
  }[];
  inputLabel?: string;
};

export const FC = (props: StyledDropDownProps & SelectProps) => {

  return (
    <FormControl
      fullWidth
      disabled={props.disabled}
      required={props.required}
      error={__isError(props) ? true : false}
    >
      {
        props.label && (
          <FormLabel>
            <Typography variant='formLabel'>{props.label}</Typography>
          </FormLabel>
        )
      }
      {props.inputLabel
        ? (
          <InputLabel
            sx={{
              marginTop: '.5rem',
              color: '#747D90'
            }}
          >
            {props.inputLabel}
          </InputLabel>
        )
        : (<></>)}

      <Select
        variant='standard'
        label={props.inputLabel ? props.inputLabel : undefined}
        placeholder={props.placeholder ? props.placeholder : undefined}
        disabled={props.disabled}
        endAdornment={props.endAdornment}
        multiple={props.multiple}
        startAdornment={props.startAdornment}
        value={props.value ?? ''}
        disableUnderline
        name={props.name}
        MenuProps={props.multiple
          ? {
            sx: {
              maxHeight: '40%'
            }
          }
          : {
          }}
        onChange={(e) => props.onChange(e)}
      >
        <MenuItem
          onClick={(e) => e.stopPropagation()}
          value=''
        >
          None
        </MenuItem>

        {props.options.map((option, i) => (
          <MenuItem
            onClick={(e) => e.stopPropagation()}
            key={i}
            value={option.id}
          >
            {option.displayName}
          </MenuItem>
        ))}

      </Select>
      {
        __isError(props)
          ? (
            <FormHelperText variant='standard'>
              {props.validationErrorMessage}
            </FormHelperText>
          )
          : (<></>)
      }
    </FormControl>

  );
};

function __isError(props: StyledDropDownProps & SelectProps) {
  return props.validationErrorMessage && props.validationErrorMessage.length > 1 && props.validationErrorMessage !== 'Required.';
}



